import { useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, IconButton } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import { useRecalculation } from './queries';
import { parseApiError, isErrorResponse } from '../../../../../utils/apiErrors';

export interface Props {
  onUpdate: () => void;
  onClose: () => void;
}

export function RecalculationDialog({ onUpdate, onClose }: Props) {
  const [error, setError] = useState('');

  const { refetch, isLoading } = useRecalculation();

  const onSubmit = async () => {
    try {
      const result = await refetch();

      if (isErrorResponse(result.data)) {
        setError(parseApiError(result.data));
        return;
      }

      onUpdate();
    } catch (err) {
      setError(parseApiError(err));
    }
  };

  return (
    <Dialog maxWidth="xs" open>
      <DialogTitle align="center">Пересчет рейтинга</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        Вы уверены, что хотите пересчитать рейтинг?
        <br />
        {error && <p className="error-message">{error}</p>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
          Отмена
        </Button>
        <Button onClick={onSubmit} disabled={isLoading} startIcon={isLoading && <CircularProgress size={20} />}>
          Ок
        </Button>
      </DialogActions>
    </Dialog>
  );
}
